export default __webpack_public_path__ + "static/media/curriculum-vitae.a0f049a7.svg";